export const CLIENT_ERROR = "Client error";
export const SERVER_ERROR = "Server error";
